import { Component, OnInit, ViewChild } from '@angular/core';
import { PlantingSiteDto } from '../../../models/trofaco/plantingSiteDto';
import { PhotoCollectionDto } from '../../../models/trofaco/photoCollectionDto';
import { PhotoDto } from '../../../models/trofaco/photoDto';
import { FrontendRouteService } from '../frontend-route.service';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
    selector: 'app-collection-dialog',
    templateUrl: './collection-dialog.component.html',
    styles: []
})
export class CollectionDialogComponent implements OnInit {
    @ViewChild(ModalDirective, {static: true}) modal: ModalDirective;
    site: PlantingSiteDto;
    collection: PhotoCollectionDto;
    activePhoto: PhotoDto;

    constructor(private frontendRoute: FrontendRouteService) {
    }

    ngOnInit() {
        this.frontendRoute.currentSite$.subscribe(s => this.site = s);
        this.frontendRoute.currentCollection$.subscribe(c => this.collection = c);
        this.frontendRoute.currentPhoto$.subscribe(p => this.activePhoto = p);
    }

    public show() {
        this.modal.show();
    }
}
